// extracted by mini-css-extract-plugin
var _1 = "ModalBody-CTzkP";
var _2 = "Paragraph-WUTS9";
var _3 = "Pink-xJesu";
var _4 = "Title-BwYP9";
export { _1 as "ModalBody", _2 as "Paragraph", _3 as "Pink", _4 as "Title" }
